import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AdminDataProvider } from "src/app/hubadmin/shared/providers/master-provider/admin-data.provider";
import { ApiConfiguration } from "src/app/services/http/api-configuration";
import { ApiService } from "src/app/services/http/api.service";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { AlertService } from "src/app/shared/providers/AlertProvider";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";

@Component({
  selector: 'app-cooler-rejection-reason',
  templateUrl: './cooler-rejection-reason.component.html',
  styleUrls: ['./cooler-rejection-reason.component.scss']
})
export class CoolerRejectionReasonComponent implements OnInit {
  selection_value ="";
  rejection_resions;
   constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private modalService: NgbModal,
    public exportExcelService: ExportExcelService,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    public alertService: AlertService
  ) {
   
  }

  ngOnInit() {
    this.getChillerRejection();
  }

  getChillerRejection() {
    this.apiService.get(this.apiConfig.coolerRejectionReason)
      .subscribe(
        (res: any) => {
         this.rejection_resions = res.data;
         console.log(this.rejection_resions)
        },
        (err) => {
          console.log(err);
        }
      );
  }

  addChillerSelection(template) {
    
    this.showStateModal(template);
   
  }


  showStateModal(template) {
    this.modalService.open(template, {
      centered: true,
      backdrop: "static",
    });
  }
  decline(): void {
    this.modalService.dismissAll();
   
  }

  onSubmit(data) {
    if (this.selection_value == "") {
      this.toast.Error("Field required");
    }
    else{
      var payload = 
      {
        chiller_selection_name:this.selection_value,
      }
      
      this.apiService.post(this.apiConfig.coolerRejectionReasonPost ,payload)
      .subscribe((res : any)=>{
        console.log(res)
        this.getChillerRejection()
        this.decline();
        this.selection_value = "";
      })
    } 
  } 
  validateTextField(value){
  if((value.charCode > 64 && value.charCode < 91) || (value.charCode > 96 && value.charCode < 123) || value.charCode == 8 || value.charCode == 32 || (value.charCode >= 48 && value.charCode <= 57)){
    console.log(value);
    // return value
  }else{
   console.log("else",value)
  }

  }
  public e: any;
  omit_special_char(event)
  {   
     var k;  
     k = event.charCode; 
     return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }
}
